import {http_client} from "../plugins/http_client";

const obtenerTiposDocumento = async (params = {}) => await http_client('/api/v1/documento-plaza/catalogo/tipo-documento', params, 'get');
const obtenerPlazas = async (params = {}) => await http_client('/api/v1/documento-plaza/catalogo/plazas', params, 'get');
const listar = async (params = {}) => await http_client('/api/v1/documento-plaza/documento-plaza', params, 'get');
const crear = async (body) => await http_client('/api/v1/documento-plaza/documento-plaza', body, 'post');
const actualizar = async (id, body) => await http_client(`/api/v1/documento-plaza/documento-plaza/${id}`, body, 'put');
const cargarPlantilla = async (archivo) => await http_client('/api/v1/documento-plaza/documento-plaza/cargar', archivo, 'post', { headers: { "content-type": "multipart/form-data" } });
const descargarPlantilla = async () => await http_client('/api/v1/documento-plaza/documento-plaza/descargar-plantilla', {}, 'get', {}, true, 'blob');
const cambiarEstado = async (id) => await http_client(`/api/v1/documento-plaza/documento-plaza/${id}/cambiar-estado`, {}, 'patch');

export default {
    obtenerTiposDocumento,
    obtenerPlazas,
    listar,
    crear,
    actualizar,
    cargarPlantilla,
    descargarPlantilla,
    cambiarEstado,
}
